export function getLiftsText(totalLifts: number | null, serviceLifts: number | null, passengerLifst: number | null) {
  if (passengerLifst && serviceLifts) {
    return `${passengerLifst} пасс., ${serviceLifts} груз.`;
  }

  if (passengerLifst && passengerLifst > 1 && !serviceLifts) {
    return `${passengerLifst} пасс.`;
  }

  if (((passengerLifst && passengerLifst === 1) || (totalLifts && totalLifts === 1)) && !serviceLifts) {
    return 'Есть';
  }

  if (serviceLifts && serviceLifts > 1) {
    return `${serviceLifts} груз.`;
  }

  if (serviceLifts) {
    return 'Есть грузовой';
  }

  if (totalLifts && totalLifts > 1) {
    return `${totalLifts} всего`;
  }

  return 'Нет';
}
